.button {
  display: grid;
  place-items: center;
  width: 105px;
  height: 42px;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  white-space: nowrap;
  border-radius: 8px;

  &:disabled {
    background-color: rgb(0 0 0 / 30%);
  }

  &:disabled,
  &[aria-disabled='true'] {
    cursor: not-allowed;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    font-size: 15px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    font-size: 15px;
  }
}

.buttonVariantsPrimary {
  color: #fff;
  background-color: #000;

  &:focus {
    outline: none;
  }

  &:hover:not(:disabled),
  &:focus-within:not(:disabled) {
    background-color: rgb(77 77 77);
  }
}

.buttonVariantsOutline {
  color: rgb(0 0 0 / 60%);
  border: 1px solid rgb(0 0 0 / 20%);

  &:focus {
    outline: none;
  }

  &:hover:not(:disabled),
  &:focus-within:not(:disabled) {
    background-color: rgb(0 0 0 / 5%);
  }
}

.buttonVariantsReadonly {
  color: #fff;
  background-color: #000;
}
